import update from 'immutability-helper';
import * as actionTypes from '../constants/actionTypes';
var initialState = {
    showTouchIndicators: false,
    isDownloaded: false,
    isLoading: true,
    isFrameless: null,
    isBasic: false,
    error: null,
    notFound: null,
    config: {},
    canvasEaselHost: 'https://easel.marvelapp.com',
};
export default function project(state, action) {
    if (state === void 0) { state = initialState; }
    if (action.type === actionTypes.LOCATION_CHANGED) {
        var projectID = action.projectID, isEmbedded = action.isEmbedded, frameOverride = action.frameOverride, isInTheExploreView = action.isInTheExploreView, hideOpenInMobile = action.hideOpenInMobile, isFrameless = action.isFrameless;
        var newState = update(state, {
            config: {
                id: { $set: projectID },
            },
            isEmbedded: { $set: isEmbedded },
            isInTheExploreView: { $set: isInTheExploreView },
            hideOpenInMobile: { $set: hideOpenInMobile },
            isFrameless: { $set: isFrameless },
            frameOverride: { $set: frameOverride },
        });
        return newState;
    }
    if (action.type === actionTypes.LOAD_PROJECT) {
        return update(state, { isLoading: { $set: true } });
    }
    if (action.type === actionTypes.LOAD_FULL_PROJECT_DONE ||
        action.type === actionTypes.SET_PROJECT) {
        // TODO need to be smarter here as part of project will have
        // been loaded if in embedded mode and first image will have
        // been preloaded
        return update(state, {
            config: { $set: action.project },
            isLoading: { $set: false },
        });
    }
    if (action.type === actionTypes.NOT_FOUND) {
        return update(state, { notFound: { $set: true } });
    }
    if (action.type === actionTypes.LOAD_FULL_PROJECT_FAILED) {
        return update(state, { error: { $set: action.err } });
    }
    if (action.type === actionTypes.SET_IS_DOWNLOADED) {
        return update(state, {
            isDownloaded: { $set: action.isDownloaded },
        });
    }
    if (action.type === actionTypes.SET_SHOW_TOUCH_INDICATORS) {
        return update(state, {
            showTouchIndicators: { $set: action.showTouchIndicators },
        });
    }
    if (action.type === actionTypes.SET_CANVAS_EASEL_URLS) {
        return update(state, {
            canvasEaselHost: { $set: action.canvasEaselHost },
        });
    }
    if (action.type === actionTypes.SET_FRAMELESS) {
        return update(state, { isFrameless: { $set: action.isFrameless } });
    }
    if (action.type === actionTypes.SET_BASIC) {
        return update(state, { isBasic: { $set: action.isBasic } });
    }
    return state;
}
